import { APP_ASSET_URL_MAX_LENGTH } from '../app-assets/index.js';
export const APP_DOWNLOAD_BUILT_IN_SOCIAL_LINKS = [
    {
        id: 'instagram',
        name: '인스타그램',
        icon: 'Instagram',
        url: 'https://www.instagram.com/boltb_official',
        visible: true,
    },
    {
        id: 'youtube',
        name: '유튜브',
        icon: 'Youtube',
        url: 'https://www.youtube.com/@boltb_official',
        visible: true,
    },
    {
        id: 'facebook',
        name: '페이스북',
        icon: 'Fb',
        url: 'https://www.facebook.com/boltb.official',
        visible: true,
    },
    { id: 'x', name: 'X', icon: 'X', url: '', visible: false },
    { id: 'tiktok', name: '틱톡', icon: 'TikTok', url: '', visible: false },
];
export const APP_DOWNLOAD_QR_ICON = 'AppDownloadQr';
export const APP_DOWNLOAD_GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.boltblive.app';
export const APP_DOWNLOAD_APP_STORE_URL = 'https://apps.apple.com/kr/app/id6751704015';
export const APP_DOWNLOAD_STORES = [
    {
        id: 'googlePlay',
        name: 'Google Play',
        url: APP_DOWNLOAD_GOOGLE_PLAY_URL,
        imageSlot: 'desktopGooglePlayButton',
    },
    {
        id: 'appStore',
        name: 'App Store',
        url: APP_DOWNLOAD_APP_STORE_URL,
        imageSlot: 'desktopAppStoreButton',
    },
];
export const APP_DOWNLOAD_IMAGE_SLOTS = APP_DOWNLOAD_STORES.map((store) => store.imageSlot);
export const APP_DOWNLOAD_ICON_NAMES = [
    APP_DOWNLOAD_QR_ICON,
    ...APP_DOWNLOAD_BUILT_IN_SOCIAL_LINKS.map((link) => link.icon),
];
export const APP_DOWNLOAD_SOCIAL_LINK_MAX_COUNT = 20;
export const APP_DOWNLOAD_SOCIAL_LINK_NAME_MAX_LENGTH = 30;
export const APP_DOWNLOAD_SOCIAL_LINK_URL_MAX_LENGTH = 2048;
export const APP_DOWNLOAD_IMAGE_URL_MAX_LENGTH = APP_ASSET_URL_MAX_LENGTH;
const SOCIAL_LINK_ID_PATTERN = /^[\da-z-]{1,40}$/;
const IMAGE_URL_PATTERN = /^https?:\/\/\S+$/;
const CONTROL_CHARACTERS = /[\u0000-\u001F\u007F]/;
const BUILT_IN_BY_ID = new Map(APP_DOWNLOAD_BUILT_IN_SOCIAL_LINKS.map((link) => [link.id, link]));
export function findAppDownloadBuiltInSocialLink(id) {
    return BUILT_IN_BY_ID.get(id);
}
function toSocialLink(link) {
    return { id: link.id, name: link.name, url: link.url, iconUrl: null, visible: link.visible };
}
export function defaultAppDownloadSocialLinks() {
    return APP_DOWNLOAD_BUILT_IN_SOCIAL_LINKS.map(toSocialLink);
}
export function withAppDownloadBuiltInSocialLinks(links) {
    const ids = new Set(links.map((link) => link.id));
    return [
        ...links,
        ...APP_DOWNLOAD_BUILT_IN_SOCIAL_LINKS.filter((link) => !ids.has(link.id)).map(toSocialLink),
    ];
}
export function isAppDownloadHttpUrl(value) {
    if (value !== value.trim() || /\s/.test(value))
        return false;
    try {
        const url = new URL(value);
        return url.protocol === 'http:' || url.protocol === 'https:';
    }
    catch {
        return false;
    }
}
export function isValidAppDownloadImageUrl(value) {
    return value.length <= APP_DOWNLOAD_IMAGE_URL_MAX_LENGTH && IMAGE_URL_PATTERN.test(value);
}
export function appDownloadSocialLinkProblem(link) {
    if (!SOCIAL_LINK_ID_PATTERN.test(link.id))
        return 'id';
    const name = link.name;
    if (name !== name.trim() ||
        name.length === 0 ||
        name.length > APP_DOWNLOAD_SOCIAL_LINK_NAME_MAX_LENGTH ||
        CONTROL_CHARACTERS.test(name)) {
        return 'name';
    }
    if (link.url === '') {
        if (link.visible)
            return 'url';
    }
    else if (link.url.length > APP_DOWNLOAD_SOCIAL_LINK_URL_MAX_LENGTH ||
        !isAppDownloadHttpUrl(link.url)) {
        return 'url';
    }
    if (link.iconUrl === null) {
        if (!BUILT_IN_BY_ID.has(link.id))
            return 'iconUrl';
    }
    else if (!isValidAppDownloadImageUrl(link.iconUrl)) {
        return 'iconUrl';
    }
    return null;
}
export function appDownloadSocialLinksProblem(links) {
    if (links.length > APP_DOWNLOAD_SOCIAL_LINK_MAX_COUNT)
        return { reason: 'tooMany' };
    const ids = new Set();
    for (const [index, link] of links.entries()) {
        const field = appDownloadSocialLinkProblem(link);
        if (field !== null)
            return { reason: 'invalidLink', index, field };
        if (ids.has(link.id))
            return { reason: 'duplicateId', index };
        ids.add(link.id);
    }
    const missing = APP_DOWNLOAD_BUILT_IN_SOCIAL_LINKS.find((link) => !ids.has(link.id));
    return missing ? { reason: 'missingBuiltIn', id: missing.id } : null;
}
export function isValidAppDownloadStoreUrl(value) {
    return value.length <= APP_DOWNLOAD_SOCIAL_LINK_URL_MAX_LENGTH && isAppDownloadHttpUrl(value);
}
//# sourceMappingURL=index.js.map